<template>
  <div id="publishAudioBox">
    <div class="publishPreviewNav">
      <img src="../../../../img/logo.png" alt="" />
      <span class="publishNavTitle">大百科</span>
    </div>
    <div class="audioContentBox">
      <h2 class="audioPageTitle">
        {{ articleTitle }}
      </h2>
      <div class="audioMainBox">
        <el-row class="topBox">
          <el-col :xs="24" :lg="5" class="time">
            <i class="el-icon-timer" style="margin-right: 5px"></i>
            <span>添加时间：{{ videoInfo.addTime }}</span>
          </el-col>
          <el-col :xs="24" :lg="4" class="hits">
            <i class="el-icon-view" style="margin-right: 5px"></i>
            <span>点击量：{{ hits }}</span>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="15"
            :xl="15"
            class="fontButton"
          >
            <span class="pointer enlarge" @click="fontLarge()"></span>
            <span class="pointer narrow" @click="fontNarrow()"></span>
          </el-col>
        </el-row>
        <div class="audioBox">
            <div class="iconBox">
                <img src="../../../../img/icon35.png" alt="" id="iconBg">
                <img src="../../../../img/icon38.png" alt="" class="iconMini">
            </div>
            <div class="audioPlayBox">
                <audio controls style="width: 90%;" v-if="audioUrl !=''" @play="handlePlay" @pause="handlePause">
                    <source :src="audioUrl" type="audio/mp3" />
                </audio>
            </div>
            <div class="subjectBox clearfix">
                <span style="background: #cd2022;color: #fff;font-size: 12px;padding: 5px 15px;border-radius: 20px;margin-top: 7px;">曲目分类</span>
                <span style="color: #555;font-size: 26px;font-weight: bolder; margin-left: 20px;">{{ videoInfo.name }}</span>
            </div>
        </div>
      </div>
    </div>

    <div class="publishFooter">
      <div class="footerContent">
        <p>版权所有 © 北京百科在线文化传媒有限公司</p>
        <p>京ICP备12000488号-2</p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      articleTitle: "",
      audioUrl: "",
      videoInfo: "",
      videoPoster: "",
      currentId: "",
      listData: [],
      hits: "",
      pageTitle: "",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateScrollDistance);

    let that = this;
    $.ajax({
      type: "GET",
      dataType: "json",
      url: "/zyk/resource/preview",
      data: { id: this.$route.query.id },
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        if (response.code == 200) {
          var data = response.obj;
          that.articleTitle = data.title;
          that.hits = data.hits;
          that.audioUrl = data.httpPath;
          that.videoInfo = data.subjectInfo;
          document.title = data.title + "-大百科";
        } else {
          that.$message({
            message: response.msg,
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
          window.location.href = "/blank";
        }
      },
      error: function () {
        window.location.href = "/blank";
      },
    });
  },
  methods: {
    handleVideoEnded() {
      console.log("视频播放完毕");
      $(".finishInfo").show();
    },
    // 字体放大s
    fontLarge() {
      $(".fontsize").each(function () {
        var cssfontSize, csslineHeight;
        if ($(this).hasClass("adv-content")) {
          cssfontSize = $(this).find("p").css("font-size");
          csslineHeight = $(this).find("p").css("line-height");
        } else {
          cssfontSize = $(this).css("font-size");
          csslineHeight = $(this).css("line-height");
        }

        var unit = cssfontSize.slice(-2);
        var fontSize = parseFloat(cssfontSize);
        var lineHeight = parseFloat(csslineHeight);
        if (fontSize > 22) return false;
        fontSize = fontSize + 2;
        lineHeight = lineHeight + 2;
        if ($(this).hasClass("adv-content")) {
          $(this)
            .find("*")
            .css("font-size", fontSize + unit);
          $(this)
            .find("*")
            .css("line-height", lineHeight + unit);
        } else {
          $(this).css("font-size", fontSize + unit);
          $(this).css("line-height", lineHeight + unit);
        }
      });
    },
    // 字体缩小
    fontNarrow() {
      $(".fontsize").each(function () {
        var cssfontSize, csslineHeight;
        if ($(this).hasClass("adv-content")) {
          cssfontSize = $(this).find("p").css("font-size");
          csslineHeight = $(this).find("p").css("line-height");
          if (!cssfontSize) {
            cssfontSize = 16;
            csslineHeight = 28;
          }
        } else {
          cssfontSize = $(this).css("font-size");
          csslineHeight = $(this).css("line-height");
        }

        var unit = cssfontSize.slice(-2);
        var fontSize = parseFloat(cssfontSize);
        var lineHeight = parseFloat(csslineHeight);
        if (fontSize < 14) return false;
        fontSize = fontSize - 2;
        lineHeight = lineHeight - 2;
        if ($(this).hasClass("adv-content")) {
          $(this)
            .find("*")
            .css("font-size", fontSize + unit);
          $(this)
            .find("*")
            .css("line-height", lineHeight + unit);
        } else {
          $(this).css("font-size", fontSize + unit);
          $(this).css("line-height", lineHeight + unit);
        }
      });
    },
    handlePlay() {
      $("#iconBg").addClass("spin");

    },
    handlePause() {
      $("#iconBg").removeClass("spin");
    }
  },
};
</script>

<style>

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.spin {
  animation: spin 10s linear infinite; /* 动画名称，持续时间，速度曲线，无限重复 */
}

#publishAudioBox {
  border-left: 5px solid #cd2022;
  background: #f6f6f6;
  height: 100%;
}

#publishAudioBox .audioContentBox {
  width: 55vw;
  padding: 90px 0 50px;
  margin: 0 auto;
}

#publishAudioBox .audioContentBox .audioPageTitle {
  color: #000000;
  font-size: 40px;
  line-height: 52px;
  font-weight: bold;
  margin-bottom: 20px;
}

/* #publishAudioBox .audioContentBox .audioMainBox {
  border: 1px solid #eee;
} */

#publishAudioBox .audioContentBox .audioMainBox .topBox {
  background-color: #eeeeee;
  border-bottom: 2px solid #cd2022;
  padding: 13px 15px;
  color: #909090;
  font-size: 12px;
  line-height: 24px;
}

#publishAudioBox .audioContentBox .audioMainBox .audioBox{
    padding-top: 20px;
}

#publishAudioBox .audioContentBox .audioMainBox .audioBox .iconBox{
  text-align: center;
  position: relative;
}

#publishAudioBox .audioContentBox .audioMainBox .audioBox .iconBox .iconMini{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

#publishAudioBox .audioContentBox .audioMainBox .audioBox .audioPlayBox{
    text-align: center;   
}

#publishAudioBox .audioContentBox .audioMainBox .subjectBox{
    background-color: #eee;
    padding: 40px 40px 30px;
    margin-top: -30px;
}

#publishAudioBox .audioContentBox .audioMainBox .subjectBox span{
    display: block;
    float: left;
}

#publishAudioBox .fontButton {
  text-align: right;
}

#publishAudioBox .fontButton .enlarge {
  background: url(../../../../img/icon9.png) no-repeat center center;
  display: inline-block;
  width: 18px;
  height: 23px;
  margin: 0px 10px;
}

#publishAudioBox .fontButton .narrow {
  background: url(../../../../img/icon10.png) no-repeat center center;
  display: inline-block;
  width: 18px;
  height: 23px;
  margin: 0px 10px;
}

#publishAudioBox .publishPreviewNav {
  box-shadow: 0px 0px 24px 0px #0000001c;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 999;
  padding: 15px 30px;
}

#publishAudioBox .publishPreviewNav .publishNavTitle {
  font-size: 24px;
  font-weight: bolder;
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  margin-left: 10px;
}

#publishAudioBox .publishFooter {
  width: 100%;
  background-color: #2f2f2f;
  padding: 50px 0;
}

#publishAudioBox .publishFooter .footerContent {
  text-align: center;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.38);
  font-size: 14px;
}

#publishAudioBox .publishFooter .footerContent p + p {
  margin-top: 10px;
}

@media screen and (max-width: 1200px) {
  #publishAudioBox .audioContentBox {
    width: 95vw;
  }

  #publishAudioBox
    .audioContentBox
    .audioBox
    .publishViewRightBox
    .videoContent {
    padding: 10px 15px;
  }
}

@media screen and (max-width: 768px) {
  #publishAudioBox .audioContentBox {
    width: 90vw;
    padding: 70px 0 0;
  }
  #publishAudioBox .audioContentBox .audioPageTitle {
    font-size: 20px;
    margin-bottom: 0;
  }
  /* #publishAudioBox .audioContentBox .audioBox {
    height: 28.5vh;
  } */

  #publishAudioBox .audioContentBox .audioBox {
    height: auto;
    width: 100%;
  }

  #publishAudioBox
    .audioContentBox
    .audioBox
    .publishViewRightBox
    .videoContent {
    padding: 10px 0;
  }

  #publishAudioBox .videoContent .contentBottom .zjjs {
    margin-top: 5px;
  }

  #publishAudioBox .videoContent .contentTop .info {
    font-size: 12px;
  }
}
</style>